export interface IFinder {
    _id: string;
    text:string;
    filter:string;
    data:any;
}

export class Finder implements IFinder {
    _id: string='';
    text:string='';
    filter:string='';
    data:any={}
}